// ABOUTME: Public landing page with editorial serif typography and feature panels
// ABOUTME: Full-bleed image backgrounds with overlay text, cream/ink palette throughout

import { Link } from 'react-router-dom'

const features = [
  {
    title: 'Wardrobe Scanner',
    description: 'Photograph and organize every piece you own',
    image: '/content/images/feature-wardrobe.webp',
  },
  {
    title: 'Style Education',
    description: 'Learn the fundamentals of dressing well',
    image: '/content/images/feature-education.webp',
  },
  {
    title: 'Daily Challenges',
    description: 'Build better habits through gamified styling tasks',
    image: '/content/images/feature-challenges.webp',
  },
  {
    title: 'Outfit Builder',
    description: 'Create and save perfect combinations',
    image: '/content/images/feature-outfits.webp',
  },
]

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-bg">
      <section className="px-5 pt-20 pb-12 text-center max-w-lg mx-auto">
        <p className="gm-eyebrow mb-3">Est. 2025</p>
        <h1 className="gm-display mb-4" style={{ fontSize: 48, lineHeight: 1 }}>
          Gentlemen
        </h1>
        <p className="font-serif-text italic text-base text-fg-secondary mb-8 max-w-xs mx-auto">
          A fashion education app for the modern man
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/auth" className="btn-primary px-8 py-3">
            Get Started
          </Link>
          <a href="#features" className="btn-accent px-8 py-3">
            Learn More
          </a>
        </div>
      </section>

      <section id="features" className="px-5 pb-6">
        <div className="max-w-3xl mx-auto mb-5">
          <p className="gm-eyebrow text-center mb-1">What We Offer</p>
          <div className="h-px bg-cream-300 w-12 mx-auto" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="relative rounded-[10px] overflow-hidden aspect-[4/3] border border-cream-300"
            >
              <img
                src={feature.image}
                alt={feature.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3
                  className="font-serif text-xl text-white mb-1"
                  style={{ letterSpacing: '-0.01em' }}
                >
                  {feature.title}
                </h3>
                <p className="font-serif-text italic text-sm text-white/70">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="px-5 py-12 text-center">
        <p className="font-serif-text italic text-sm text-fg-tertiary mb-4">
          Free to start. No credit card required.
        </p>
        <Link to="/auth" className="btn-accent px-8 py-3">
          Create Account
        </Link>
      </section>
    </main>
  )
}
